import EnterpriseFormAddress from '../EnterpriseFormAddress';
import EnterpriseFormDetails from '../EnterpriseFormDetails';
import EnterpriseFormVideo from '../EnterpriseFormVideo';
import { Grid } from '@mui/material';
import useCreateEnterprise from '@enterprise/hooks/useCreateEnterprise';
import { useEffect } from 'react';

const EnterpriseDetails = () => {
  const { setMode } = useCreateEnterprise();
  useEffect(() => {
    setMode('edit');
  }, [setMode]);
  return (
    <Grid container gap={3}>
      <Grid item xs={3.8}>
        <EnterpriseFormDetails includeFooter={false} />
      </Grid>
      <Grid item xs={3.8}>
        <EnterpriseFormAddress includeFooter={false} />
      </Grid>
      <Grid item xs={3.8}>
        <EnterpriseFormVideo includeFooter={false} />
      </Grid>
    </Grid>
  );
};

export default EnterpriseDetails;
